module.exports = __webpack_public_path__ + "img/Adii.f92d8bd0.jpg";